import React from 'react'

import Tooltip from '@material-ui/core/Tooltip';
import NudgeCell from "./NudgeCell";

export default class SendCell extends React.Component {
  constructor(props){
    super(props)

    this.state = {

    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let {

    } = this.state

    return (
      <Tooltip title={this.props.tooltip} placement="top" arrow> 
        <a className="btn btn-icon btn-light btn-hover-primary btn-sm"
           style={{margin: 3}}
           onClick={e => this.props.onSendClicked()}
        >
          <i className="la la-send text-primary icon-md"></i>
        </a>
      </Tooltip>
    )
  }
}

SendCell.defaultProps = {
  tooltip: 'Resend'
}